export enum IcpAutomationsTabsEnum {
    EXISTING_AUTOMATIONS = 'EXISTING AUTOMATIONS',
    NEW_AUTOMATION = 'NEW AUTOMATION',
}
